// extracted by mini-css-extract-plugin
module.exports = {"technology":"technology-module--technology--2oZQ9","name":"technology-module--name--2yI02"};